import React, { lazy, Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import { routePaths } from '@/constants';

const Dashboard = lazy(() => import('@/features/dashboard'));
const Survey = lazy(() => import('@/features/survey/index'));
const DatasetsAdmin = lazy(() => import('@/features/datasets/admin/index'));
const ClientIdsIndex = lazy(() => import('@/features/client-ids/admin/index'));
const ClientIdsDetail = lazy(
  () => import('@/features/client-ids/admin/detail'),
);
const VarassetExports = lazy(() => import('@/features/varasset-exports'));
const QuestionnaireAdmin = lazy(
  () => import('@/features/questionnaires/admin/index'),
);
const notAuthorized = lazy(() => import('@/app/not-authorized'));
const noticeHistory = lazy(() => import('@/features/loss-notices/history'));
const mediaAttachments = lazy(
  () => import('@/features/reporting/media-attachment'),
);

const Routes: React.FC = () => (
  <Suspense fallback={<div>Loading...</div>}>
    <Switch>
      <Route exact={true} path={routePaths.dashboard} component={Dashboard} />
      <Route
        path={[
          routePaths.survey.lossNotice,
          routePaths.survey.questionnaire,
          routePaths.survey.questionnaireRevision,
        ]}
        component={Survey}
      />
      <Route
        path={[routePaths.admin.varassetExports]}
        component={VarassetExports}
      />
      <Route path={[routePaths.lossNotice.history]} component={noticeHistory} />
      <Route
        exact={true}
        path={routePaths.admin.clientId.index}
        component={ClientIdsIndex}
      />
      <Route
        path={routePaths.admin.clientId.detail}
        component={ClientIdsDetail}
      />
      <Route path={routePaths.admin.datasets.index} component={DatasetsAdmin} />
      <Route
        path={routePaths.admin.questionnaires.index}
        component={QuestionnaireAdmin}
      />
      <Route
        path={routePaths.reporting.mediaAttachment}
        component={mediaAttachments}
      />
      <Route path={routePaths.notAuthorized} component={notAuthorized} />
    </Switch>
  </Suspense>
);

export default Routes;
